.heading {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.8;
}
